import {
  GET_MATCH_CARD_STATISTIC_MARKETS_REQUEST,
  GET_MATCH_CARD_STATISTIC_MARKETS_SUCCESS,
  GET_MATCH_CARD_STATISTIC_MARKETS_FAILURE,
  RESET_MATCH_CARD
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  isFetched: false,
  eventId: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MATCH_CARD_STATISTIC_MARKETS_REQUEST:
      return { ...state, isLoading: true };

    case GET_MATCH_CARD_STATISTIC_MARKETS_SUCCESS:
      return { ...state, isLoading: false, isFetched: true, data: action.payload, eventId: action.eventId };

    case GET_MATCH_CARD_STATISTIC_MARKETS_FAILURE:
      return { ...state, isLoading: false, isFetched: false, error: action.payload };

    case RESET_MATCH_CARD:
      return { ...initialState };

    default: return state;
  }
};
